// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1i-2";
export var blackBorderOnHover = "_1i-7";
export var cell = "_1i-6";
export var cellContainer = "_1i-3";
export var checked = "_1i-8";
export var disabled = "_1i-5";
export var featuredIconCellContainer = "_1i-9";
export var featuredIconTextContainer = "_1i-b";
export var featuredIconWrapper = "_1i-a";
export var noBorder = "_1i-c";
export var orangeSelectedRow = "_4l-3";
export var overflowableText = "_1i-0";
export var overflowableTextContainer = "_1i-1";
export var row = "_1h-0";
export var rowCheckboxCell = "_1i-4";
export var selectableTable = "_4l-2";